
import { ChallengeCreate } from './ChallengesCreate';
import { ChallengeEdit } from './ChallengesEdit';

export default {
    edit: ChallengeEdit,
    create: ChallengeCreate
};
